export enum Permission {
    admin = 1,
    simulation = 3,
    user = 2
}